import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.regexp.search.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import USE_MARKETPLACE from '~/const/marketplace';
import searchSuggestionQuery from '~/graphql/searchSuggestion.gql';
import searchSuggestionAlgoliaQuery from '~/graphql/searchSuggestionAlgolia.gql';
import SEARCH_PROVIDER from '~/helpers/search-data-helpers';
export default {
  props: {
    search: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      results: {},
      loading: false,
      timeout: 3000
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    provider: 'search/provider'
  })), {}, {
    getAlgoliaIndex() {
      var {
        algolia
      } = this.$store.state.sharedEnv.payload;
      return algolia;
    },
    isMarketplace() {
      return USE_MARKETPLACE(this);
    },
    isAlgoliaProvider() {
      return SEARCH_PROVIDER(this) === 'algolia';
    }
  }),
  watch: {
    immediate: true,
    search() {
      if (this.search.length === 0) {
        this.results = {};
        return this.results;
      }
      this.debounceGetSuggestion();
    }
  },
  methods: {
    debounceGetSuggestion: debounce( /*#__PURE__*/function () {
      var _getSuggestions = _asyncToGenerator(function* () {
        yield this.getResults();
        this.$emit('results-received', this.results);
      });
      function getSuggestions() {
        return _getSuggestions.apply(this, arguments);
      }
      return getSuggestions;
    }(), 200),
    getResults() {
      var _this = this;
      return _asyncToGenerator(function* () {
        var response;
        if (SEARCH_PROVIDER(_this) === 'algolia') {
          var canRunSearch = _this.search.length >= 3;
          try {
            if (canRunSearch) {
              var controller = new AbortController();
              var timeoutFallback = setTimeout(() => controller.abort(), _this.timeout);
              response = yield _this.getAlgoliaCorvusSuggestions();
              _this.fallbackErrors(response, controller);
              clearTimeout(timeoutFallback);
              _this.results = response;
              return;
            }
          } catch (e) {
            response = yield _this.getSuggestions();
            _this.results = response;
            _this.$logger.error(e);
          }
        } else {
          response = yield _this.getSuggestions();
          _this.results = response;
        }
      })();
    },
    getAlgoliaCorvusSuggestions() {
      var _this2 = this;
      return _asyncToGenerator(function* () {
        var algoliaUserToken = _this2.$cookies.get('_ALGOLIA') || '';
        _this2.loading = true;
        try {
          var {
            data: {
              searchSuggestionsMultiQuery: {
                ABTests,
                queryIDS,
                products: algoliaProducts,
                categories: algoliaCategories,
                suggestions
              }
            }
          } = yield _this2.$apolloProvider.defaultClient.query({
            query: searchSuggestionAlgoliaQuery,
            variables: {
              locale: _this2.locale.iso,
              keyword: _this2.search,
              offset: 0,
              sortBy: 'POPULAR',
              orderBy: 'DEFAULT',
              filterBy: [],
              algoliaUserToken,
              withMarketplace: _this2.isMarketplace
            }
          });
          _this2.loading = false;
          var {
            products: algoliaSuggestProducts,
            total: totalProducts,
            queryID,
            provider
          } = algoliaProducts;
          var categories = algoliaCategories.map((category, i) => _objectSpread(_objectSpread({}, category), {}, {
            position: i + 1
          }));
          var total = algoliaSuggestProducts.length + categories.length;
          var products = algoliaSuggestProducts.map((product, i) => _objectSpread(_objectSpread({}, product), {}, {
            position: i + 1
          }));
          var indexedSuggestions = suggestions.map((suggestion, i) => _objectSpread(_objectSpread({}, suggestion), {}, {
            position: i + 1
          }));
          var results = {
            ABTests,
            query: _this2.search,
            queryIDS,
            // todo: delete queryID when queryIDS is used
            queryID,
            products,
            categories,
            suggestions: indexedSuggestions,
            total,
            totalProducts,
            provider
          };
          return results;
        } catch (e) {
          _this2.loading = false;
          _this2.$logger.error(e);
        }
      })();
    },
    getSuggestions() {
      var _this3 = this;
      return _asyncToGenerator(function* () {
        _this3.loading = true;
        try {
          var {
            data: {
              categorySearch,
              productSearchSuggest
            }
          } = yield _this3.$apolloProvider.defaultClient.query({
            query: searchSuggestionQuery,
            variables: {
              locale: _this3.locale.iso,
              keyword: _this3.search,
              offset: 0,
              limit: 5,
              sortBy: 'POPULAR',
              orderBy: 'DEFAULT',
              filterBy: []
            }
          });
          _this3.loading = false;
          var {
            products,
            total: totalProducts
          } = productSearchSuggest;
          var categories = categorySearch;
          var total = products.length + categories.length;
          var results = {
            query: _this3.search,
            products,
            categories,
            suggestions: [],
            total,
            totalProducts
          };
          return results;
        } catch (e) {
          _this3.loading = false;
          _this3.$logger.error(e);
        }
      })();
    },
    fallbackErrors(response, controller) {
      if (!response) {
        throw new Error('Algolia has no response in SearchDataProvider.vue (line 51) : switch to elastic');
      }
      if (controller.signal && controller.signal.aborted) {
        throw new Error('Algolia response time is exceeded in SearchDataProvider.vue (line 51) : switch to elastic');
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      keyword: this.search,
      data: this.results,
      loading: this.loading
    });
  }
};